export const colors = {
    white: '#FFFFFF',
    black: '#000000',

    'sky-50': '#F0F9FF',
    'sky-100': '#E0F2FE',
    'sky-600': '#0284C7',
    'sky-700': '#0369A1',
    'sky-900': '#0C4A6E',
    'sky-950': '#082F49',

    'red-50': '#FEF2F2',
    'red-300': '#EE5250',
    'red-400': '#D22E2F',
    'red-410': '#A41819',
    'red-900': '#881337',

    'orange-100': '#FFEDD5',
    'orange-400': '#FB923C',
    'orange-700': '#C2410C',

    'yellow-50': '#FEFCE8',
    'yellow-700': '#A16207',
    'yellow-900': '#713F12',

    'green-100': '#DCFCE7',
    'green-700': '#15803D',

    'lime-700': '#4D7C0F',

    'teal-700': '#0F766E',

    'fuchsia-800': '#86198F',

    'stone-50': '#FAFAF9',
    'stone-100': '#F5F5F4',
    'stone-200': '#E7E5E4',
    'stone-300': '#D6D3D1',
    'stone-400': '#A8A29E',
    'stone-500': '#78716C',
    'stone-600': '#57534E',
    'stone-700': '#44403C',
    'stone-800': '#292524',
    'stone-900': '#1C1917',
    'stone-950': '#0C0A09',

    'zinc-400': '#A1A1AA',

    'text-link': '#0066CC',

    'light-gray-100': '#F7F7F7',
    'light-gray-200': '#EEEEEE',
    'light-gray-300': '#DDDDDD',

    'medium-gray-300': '#888888',
    'medium-gray-400': '#777777',
    'medium-gray-500': '#666666',

    'bg-muted-hover': '#f4f4f5cc',

    'shadow-black': 'rgba(0, 0, 0, 0.1)',
};
